import { useCustomRepairTimesDefaults } from "@tm/data/basket"
import { useVatRateText } from "@tm/utils"
import { useMemo } from "react"
import { VatRateItem } from "../../models"
import { useWorkCategoryItems } from "./useWorkCategoryItems"

export function useRepairTimesFormDefaults() {
    const { customRepairTimesDefaults: { defaultVatRates } = {} } = useCustomRepairTimesDefaults()
    const { vatRateTypeDisplayLongText } = useVatRateText()

    const workCategoryItems = useWorkCategoryItems()
    const vatRateItems = useMemo<VatRateItem[]>(
        () =>
            (defaultVatRates ?? []).map((vatRate) => ({
                vatRate,
                text: vatRateTypeDisplayLongText({ vatType: vatRate.vatType, vatRate: vatRate.vatValue }),
            })),

        [defaultVatRates, vatRateTypeDisplayLongText]
    )

    return useMemo(
        () => ({
            workCategoryItems,
            vatRateItems,
        }),
        [workCategoryItems, vatRateItems]
    )
}
